module.exports = __webpack_public_path__ + "img/DiHS_Video_Icon_Sr_Video3.90ae5580.jpg";